import axios from '@/utils/request'

export default {
  emailRegisterInfo: (data) => axios({ url: '/api/store/emailRegisterInfo', method: 'post', data }), // 获取邮箱是否注册
  setRecharge: (data) => axios({ url: '/api/payment/recharge', method: 'post', data }), // 创建充值审批
  getRechargeList: (data) => axios({ url: '/api/payment/getRecharge', method: 'post', data }), // 获取审批充值列表
  getRechargeDetail: id => axios({ url: `/api/payment/recharge/${id}`, method: 'get'}), // 查看审批充值详情
  submitRecharge: id => axios({ url: `/api/payment/submit/${id}`, method: 'put'}), // 提交审批流
  revokeRecharge: id => axios({ url: `/api/payment/revoke/${id}`, method: 'put'}), // 撤销审批
}
